export default {
  navbar: {
    about: 'sobre mí',
    whatido: 'lo que hago',
    works: 'trabajos',
    journey: 'trayectoria',
    contact: 'contacto',
    theme: 'Tema',
  },
  footer: {
    rights: 'Todos los derechos reservados',
    made: 'Hecho con',
    cta: {
      title1: 'construyamos',
      title2: 'algo',
      titleAccent: 'extraordinario',
      description: '¿Tienes un proyecto en mente o simplemente quieres conectar? Hablemos.',
    },
  },
  notFound: {
    title: 'Página no encontrada',
    description: 'Lo siento, la página que estás buscando no existe o ha sido movida.',
    goHome: 'Volver al inicio',
    goBack: 'Regresar',
  },
  close: 'Cerrar',
  readMore: 'Leer más',
  readLess: 'Leer menos',
  tiltToExplore: 'Inclina para explorar',
  tapToExplore: 'Toque para explorar',
}
